<template>
  <section class="footer-box">
    <section class="disclaimer">
      <div class="context">
        <a class="goDis" href="http://pundix.com/disclaimer">Disclaimer</a>
        <div class="dis-info">
          <p class="info-note">The Information provided herein is for general information only. It should not be taken as professional consulting or financial advice from <span class="oneWorl">Pundi X</span> Labs Pte. Ltd (Singapore UEN No. 201731271H) or any affiliated <span class="oneWorl">Pundi X</span> entity (collectively referred to as “<span class="oneWorl">PUNDI X</span>”).</p>
          <p class="info-note">You should consider seeking independent legal, financial, taxation and/or other advice to confirm how participation in the activities of <span class="oneWorl">PUNDI X</span> might relate to your unique circumstances.</p>
          <p class="info-note">Presently, the activities of <span class="oneWorl">PUNDI X</span> are not regulated or licensed by the financial regulatory authorities of many jurisdictions, including the Monetary Authority of Singapore (“MAS”).</p>
          <p class="info-note"><span class="oneWorl">PUNDI X</span> remains committed to complying with all relevant regulations in force that relate to our activities.</p>
        </div>
      </div>
    </section>
    <section class="footer">
      <div class="content">
        <div class="navBox">
          <div class="logoBox">
            <router-link to="/TheScopeOfBusinessOfPundixTrademark" class="hiddenLink">
              <img src="../../assets/img/footer/bottom_logo.png" alt="logo" class="logo">
            </router-link>
          </div>
        </div>
        <div class="contactBox">
          <div class="info">Copyright &copy; 2018 - 2023 Pundi X Labs PTE. LTD. All Rights Reserved.</div>
          <div class="logoBox">
            <router-link to="/TheScopeOfBusinessOfPundixTrademark" class="hiddenLink">
              <img src="../../assets/img/footer/bottom_logo.png" alt="logo" class="logo">
            </router-link>
          </div>
          <ul class="contact">
            <li class="contactItem" v-for="(item, key) in footerLink" :key="key">
              <a :href="item.href" class="ciLink" target="_blank">
                <img :src="'/img/footer/' + item.src" alt="icon" class="cilIcon">
                <img :src="'/img/footer/' + item.srcNor" alt="icon" class="cilIconNor">
              </a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  export default {
    name: 'myfooter',
    data () {
      return {
        footerLink: [
        {
          "href": "mailto:contact@pundix.com",
          "src": "media_email.svg",
          "srcNor": "media_email_nor.svg"
        },{
          "href": "https://web.facebook.com/pundixlabs/",
          "src": "media_facwbook.svg",
          "srcNor": "media_facwbook_nor.svg"
        },{
          "href": "https://twitter.com/PundiXLabs",
          "src": "media_twiter.svg",
          "srcNor": "media_twiter_nor.svg"
        },{
          "href": "https://t.me/Pundix",
          "src": "media_telegram.svg",
          "srcNor": "media_telegram_nor.svg"
        // },{
        //   "href": "https://www.linkedin.com/company/13423325/",
        //   "src": "media_in.svg",
        //   "srcNor": "media_in_nor.svg"
        },{
          "href": "https://www.youtube.com/channel/UCOIf6WeLEzZi3DQxzenTZeA",
          "src": "media_youtube.svg",
          "srcNor": "media_youtube_nor.svg"
        }
      ]
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .footer{
    width: 100%;
    background-color: #1E1E23;
  }
  .content{
    width: 100%;
    max-width: 1256px;
    min-height: 260px;
    box-sizing: border-box;
    padding: 80px 28px 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .navBox{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .logoBox{
    width: 95px;
  }
  .hiddenLink{
    display: block;
    width: 100%;
  }
  .logo{
    display: block;
    width: 100%;
  }
  .contactBox{
    max-width: 820px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .contact{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .contactItem{
    width: 40px;
    height: 40px;
  }
  .ciLink{
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
  }
  .cilIcon{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.3s;
  }
  .cilIconNor{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.3s;
  }
  .ciLink:hover .cilIcon{
    opacity: 1;
  }
  .ciLink:hover .cilIconNor{
    opacity: 0;
  }
  .info{
    font-size: 12px;
    color: #8B8B8B;
    letter-spacing: 1px;
    text-align: right;
  }
  .disclaimer{
    width: 100%;
    background-color: #000;
  }
  .context{
    padding-top: 75px;
    padding-bottom: 55px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    background-color: #000;
    text-align: center;
  }
  .goDis{
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-decoration: underline;
  }
  .dis-info{
    margin-top: 27px;
    width: 100%;
    max-width: 620px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
  }
  .info-note{
    font-size: 10px;
    color: #646464;
  }
  .info-note+.info-note{
    margin-top: 20px;
  }
  .oneWorl{
    display: inline-block;
  }
  @media screen and (min-width: 769px){
    .contactBox .logoBox{
      display: none;
    }
  }
  @media screen and (max-width: 1100px){
    .contactBox{
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
    }
    .contact{
      order: 1;
    }
    .contactBox .logoBox{
      order: 2;
    }
    .info{
      order: 3;
    }
  }
  @media screen and (max-width: 768px){
    .navBox .logoBox{
      display: none;
    }
    .contactBox .logoBox{
      width: 46px;
      margin-top: 10px;
    }
    .info{
      margin-top: 23px;
      font-size: 10px;
      text-align: center;
    }
    .contactBox{
      align-items: center;
    }
  }
  @media screen and (max-width: 414px){
    .info-note{
      text-align: left;
    }
  }

  @media screen and (max-width: 321px){
    .info-note{
      padding-left: 40px;
      padding-right: 40px;
    }
  }
</style>